import { deleteTranscriptEpic } from './state/delete-transcript.epic';
import { reloadEpic } from './state/reload.epic';

export const transcriptSummaryEpics = [reloadEpic, deleteTranscriptEpic];
